import { Plane, Square } from 'lucide-react'
import { useEventPlannerStore } from '../store/eventPlannerStore'
import { ToolbarButton } from './ToolbarButton'

/**
 * Activate/deactivate the arrival/taxi/tow/departure motion simulation.
 *
 * Reads/writes the `enableAnimation` master switch in `motionConfig`. When off,
 * `useEventSceneSync` snaps every aircraft to its parked pose and
 * `useEventActorMotion` bails — planes are simply rendered on their designated
 * spots with no approach/taxi/tug/fuel motion (the legacy snap behavior).
 */
export function AnimationToggle({ fullWidth }: { fullWidth?: boolean }) {
  const enabled = useEventPlannerStore((s) => s.motionConfig.enableAnimation)
  const setMotionConfig = useEventPlannerStore((s) => s.setMotionConfig)

  return (
    <ToolbarButton
      icon={enabled ? <Plane className="h-4 w-4" /> : <Square className="h-4 w-4" />}
      label={enabled ? 'Animations On' : 'Animations Off'}
      accent="sky"
      active={enabled}
      fullWidth={fullWidth}
      onClick={() => setMotionConfig({ enableAnimation: !enabled })}
      title={
        enabled
          ? 'Animations are ON — click to render planes statically on their spots'
          : 'Animations are OFF — click to animate arrivals/taxi/departures'
      }
    />
  )
}
